export default "__VITE_ASSET__50tamc3w__"